<template>
    <div class="card">
      <div class="card-body">
        <slot name="title">
          <h4 class="card-title font-weight-bold">{{title}}</h4>
        </slot>
        <slot>
          <p class="card-description">{{description}}</p>
        </slot>
       
      <div   class="row pb-3">
                
                <div class="col-sm-12 col-md-6">
                <slot name="tbuttons"></slot>
                 </div>
                 <div class="col-sm-12 col-md-6">
                <slot name="tbuttons-right">
  
                </slot>
                 </div>
         </div>
      <div  class="row" >
              <slot name="free-header-options"></slot>
        </div>
         <div class="row">
                <div class="col-6"></div>
               <div class="col " v-if="showHideColumnsControl">
                <!-- TODO descomentar -->
                    <columns-table-control :headers="headers" @change-header="changeHeader($event)"  ></columns-table-control>
               </div>
            </div>
        <div :class="tableContainerClass">
           
            <div class="row">
                <div class="col">
  
                
                 <!-- <table class="table align-middle table-hover"> -->
                    <!-- nuevo estilo para tabla -->
                <table class="table align-middle table-bordered">
  
                      
                  <thead class="table-light">
                      <template v-if="showOrder">
                          <template v-for=" header in headers" >
                          <th scope="col" :key="header.index" v-if="header.visible" >
                          {{header.label}} 
                          <template v-if="filter|header.filter"><i   @click="selectedFilter(header,'DESC')" class="fa fa-caret-down" :class="{pointer: filter|header.filter, 'text-disabled': !header.selected||header.order!='DESC','text-primary': header.selected && header.order=='DESC'}"></i></template>
                           <template v-if="filter|header.filter"><i   @click="selectedFilter(header,'ASC')" class="fa fa-caret-up" :class="{ pointer: filter|header.filter ,'text-disabled': !header.selected||header.order!='ASC','text-primary': header.selected && header.order=='ASC',}"></i></template>
                      </th>                           
                          </template>
                      </template>
                      <template v-else>
                       <th scope="col" v-for=" header in headers" :key="header.index" :class="{ pointer: filter|header.filter,
                                                                                   }"
                      @click="selectedFilter(header)"
                      >
                          {{header.label}} 
                          <template v-if="filter|header.filter"><i class="mdi mdi-chevron-down" :class="{'text-disabled': !header.selected,'text-primary': header.selected,}"></i></template>                        
                      </th>                                                    
                      </template>
                      <th scope="col" v-if="addActionColumn">
                          Operacion
                      </th>
                     
                  </thead>
                  <tbody>
                      <slot name="tbody">
                          <tr>
                              <td :colspan="headers.length">
                                  No hay resultados disponibles
                                  <!--
                                  <p v-if="items.length">NO hay res</p>
                                  -->
                              </td>
                          </tr>
                      </slot>
                  </tbody>
                  </table>
                  </div>
            </div>
            
         
        </div> <!-- fin table responsive-->
        <div class="row">
                <slot name="pagination">
                    <div>
                        
                    </div>
  
                </slot>
  
            </div>
      </div>
    </div>
  </template>
  <script>
  
  // import Vue from 'vue';
  const rowsOverTableCol6='split-col-middle';
  
//   const rowsOverTableOpen='open';
  export default {
    comments:'created by Daniel Hdz Fco, daniel.hernandez.job@gmail.com',
    note:'i have to return the headers prop',
    props: {
        enableScroll: {
            type: Boolean,
            default: false
        },
      'show-order':{
          type:Boolean,
          default:false,
          note:'Este valor solo aplica cuando filter es true a nivel global o especifico'
      },
      filter:{
          type:Boolean,
          default:false,
      },
      title: String,
      description: String,
      headers: {
        default: function(){
            return []
        },
        type: Array,
        note:"every item of this array has he next structure(fields): index:1,name:' Nombre de usuario',show:true,filter:true,selected:bool"
      },
      items: {
        default: function(){
            return []
            }
      },
      clickOnFilter:{
          default:(header)=>{
              this.$emit('click-filer',header);
          },
          type:Function,
          note:'This prop acts like sustitute of selected filter'
          
      },
      addActionColumn:{
        type:Boolean,
        default:false,
        note:'Este booleando indica si se debe agregar una columna extra en el header del table'
      },
      tableOptionsRow:{
          type:String,
          default:rowsOverTableCol6,// split-col-middle-> indica que se usaran las columnas md-6, open= significa que sera el usuario quien elegira
          note:'Este parametro controla los rows que van encima del table, y van dentro del table-responsive'
      },
      showHideColumnsControl:{
          type:Boolean,
          default:false,
          note:"I added this feacture to allow show and hide column, a new control was added, by default this prop is false since it's in use and keep compatibility"
      }
    },
    mounted(){
        this.headers.forEach(h=>{
            //eslint-disable-next-line no-prototype-builtins
            if(!h.hasOwnProperty('visible')){
              // if(Object.prototype.hasOwnProperty.call(!h, 'visible')){
                //h.visible=true; //this doesn't work, because it added a propertie but that property wasn't reactive, I need to use Vue.set
              //   Vue.set(h, 'visible', true);
              h.visible=true;
              console.log('mounted'+h);
            }
        })
    },
    methods:{
        selectedFilter(header,order){
            if(header.filter){          
                header.selected=true;
                header.order=order;
  
                //me aseguro de emitir 
                
              
             // console.debug(this.headers)
              /*
              let index=this.headers.findIndex(x=>x==header);
              if(index>-1){
                  Vue.delete(this.headers[index],'selected')
              }
              Vue.set(this.headers[index], 'selected', true);
              */
              for(let h of this.headers){
                  if(h!=header)
                      h.selected=false
              }
              this.$emit('click-filter',
              {
                  selectedHeader:header,
                  headers:this.headers
              })
            }
        },changeHeader(){
              
        }
    },
    watch: {
          addActionColumn:function(newVal){
            // eslint-disable-next-line no-empty
            if(newVal && this.header){
  
            }
          }
    },
    computed: {
        tableContainerClass() {
            return {
                'table-responsive': true,
                'overflow-auto custom-scroll': this.enableScroll
            }
        }
    }
  };
  </script>
<style scoped>
    .custom-scroll {
        max-height: 400px;
    }
</style>